import styled from "@emotion/styled";

import { BREAKPOINTS } from "../../utils/consts.js";
// import Txt from "../Atoms/Txt.js";

const FormBox = (props) => {
  const {
    config,
    data,
    withPadding,
    size,
    inside,
    className,
    title,
    description,
    titleAlign,
    hint,
    hintIcon,
  } = props;

  let width;
  switch (size) {
    case "small":
      width = 350;
      break;
    case "normal":
    default:
      width = 500;
  }

  return (
    <StyledFormBox
      config={config}
      className={className}
      logo={data?.logo}
      withPadding={withPadding}
      width={width}
    >
      {title || description || hint ? (
        <div className={"text-content"}>
          {title && title.length && (
            <span
              className={`box-title ${titleAlign}`}
              dangerouslySetInnerHTML={{ __html: title }}
            />
          )}
          {description && description.length && (
            <span
              className={"box-description"}
              dangerouslySetInnerHTML={{ __html: description }}
            />
          )}
          {hint ? (
            <div className={"hint-box"}>
              {hintIcon}
              <span dangerouslySetInnerHTML={{ __html: hint }} />
            </div>
          ) : (
            <></>
          )}
        </div>
      ) : (
        <></>
      )}
      {inside}
    </StyledFormBox>
  );
};

export default FormBox;

/* style */

const StyledFormBox = styled.div`
  width: ${(props) => props.width}px;
  max-width: 100vw;

  @media (max-width: ${BREAKPOINTS.PHONE}px) {
    width: 100vw;
    padding: 0px 16px;
  }

  .logo-container {
    display: flex;
    justify-content: start;
    margin-bottom: 15px;

    .logo {
      display: inline-block;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      width: clamp(100px, calc(15vw), 150px);
      height: clamp(60px, calc(7vw), 80px);
      background-image: url(${(props) => props.logo});
    }
  }

  .text-content {
    display: flex;
    flex-direction: column;
    margin-bottom: 48px;
    gap: 8px;

    span {
      text-align: center;
    }

    .box-title {
      font-family: "Roboto Condensed";
      font-size: 32px;
      line-height: 41px;
      font-weight: 700;
      color: #006e3d;
      white-space: nowrap;
      text-transform: uppercase;

      &.center {
        text-align: center;
      }
    }

    .box-description {
      font-family: "Roboto";
      font-size: 16px;
      line-height: 25px;
      font-weight: 400;
      flex-direction: column;
      color: #8c8c8c;
    }

    .hint-box {
      display: flex;
      flex-direction: row;
      border-radius: 8px;
      margin-top: 20px;
      padding: 12px;
      gap: 12px;
      align-items: center;
      color: #006e3d;
      background-color: rgba(0, 0, 0, 0.04);

      svg {
        width: 30px;
        height: 30px;
      }

      @media (max-width: ${BREAKPOINTS.TABLET_PORTRAIT}px) {
        margin-top: -10px;
        padding: 8px;
        gap: 8px;

        svg {
          width: 24px;
          height: 24px;
        }
      }
    }

    @media (max-width: ${BREAKPOINTS.TABLET_PORTRAIT}px) {
      margin-bottom: 32px;
      gap: 32px;

      .box-title {
        &.center {
          font-size: 3.5rem;
        }
      }
    }

    @media (max-width: ${BREAKPOINTS.PHONE}px) {
      .box-title {
        &.center {
          font-size: 2.5rem;
        }
      }
    }
  }
`;
